'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends3 = require('babel-runtime/helpers/extends');

var _extends4 = _interopRequireDefault(_extends3);

exports.default = reducer;
exports.show = show;
exports.hide = hide;
exports.toggle = toggle;
exports.toggleSection = toggleSection;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Side menu redux reducer and action creators */

var SHOW = 'menu/SHOW';
var HIDE = 'menu/HIDE';
var TOGGLE = 'menu/TOGGLE';
var TOGGLE_SECTION = 'menu/TOGGLE_SECTION';

var initialState = {
  visible: false,
  hiddenSections: {}
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case 'RESET':
      return initialState;
    case SHOW:
      return (0, _extends4.default)({}, state, {
        visible: true
      });
    case HIDE:
      return (0, _extends4.default)({}, state, {
        visible: false
      });
    case TOGGLE:
      return (0, _extends4.default)({}, state, {
        visible: !state.visible
      });
    case TOGGLE_SECTION:
      return (0, _extends4.default)({}, state, {
        hiddenSections: (0, _extends4.default)({}, state.hiddenSections, (0, _defineProperty3.default)({}, action.section, !state.hiddenSections[action.section]))
      });
    default:
      return state;
  }
}

function show() {
  return {
    type: SHOW
  };
}

function hide() {
  return {
    type: HIDE
  };
}

function toggle() {
  return {
    type: TOGGLE
  };
}

function toggleSection(section) {
  return {
    type: TOGGLE_SECTION,
    section: section
  };
}


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/sidemenu.js
// module id = 871
// module chunks = 1